import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ModalTerminiCondizioni } from 'src/components/Modals';
import { SEO } from 'src/components/SEO';

export const Terms: React.FC = () => {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate(-1); // Torna alla pagina precedente
  };

  if (!open) return null;
  return (
    <>
      <SEO
        title="Termini e Condizioni - Kipify"
        robots="noindex, nofollow"
        canonical="https://app.kipify.io/terms"
      />
      <ModalTerminiCondizioni open={open} onClose={handleClose} />
    </>
  );
};
